<template>
  <el-container class="error">
    <el-row type="flex" justify="center">
      <el-col :xs="20" :sm="10" :md="8" :lg="6" :xl="6">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span class="error__header-text-color">
              {{$t('errors.unknown.title')}}
            </span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="logout">{{$t('errors.unknown.button')}}</el-button>
          </div>
          {{$t('errors.unknown.text')}}
        </el-card>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
  // store
  import { AUTH_LOGOUT } from "../../store/actions/auth";

  export default {
    name: "unknownError",
    methods: {
      logout() {
        localStorage.clear();
        this.$store.dispatch(AUTH_LOGOUT);
      }
    }
  }
</script>

<style>
  @import "./css/style.css";
</style>
